class CustomerTransformationsV2 extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('.customer-transformations-v2__carousel');
    if (!this.carousel || window.matchMedia('(min-width: 700px)').matches) return;

    const cards = this.querySelectorAll('.customer-transformations-v2__card');
    if (cards.length < 2) return;

    requestAnimationFrame(() => {
      cards[1].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
    });
  }
}

if (!customElements.get('customer-transformations-v2')) {
  customElements.define('customer-transformations-v2', CustomerTransformationsV2);
}
